import React from 'react';
import FaIcon from '../utils/FaIcon';

const Contact = () => {
  return (
    <div className='contacts-page'>
      <div className='cards-wrapper full-width'>
        <div className='card right-text width-40'>
          <h3 style={{ color: '#e47931' }}>Contact Us</h3>
          <h1>Get in Touch with Us</h1>
          <p>If you have any questions or inquiries, feel free to reach out to us. We are here to help you!</p>
          <p>Or, leave us a message in the form below. We will reach out to you.</p>
          <h3 style={{ color: '#e47931', marginLeft: '3rem' }}>Contact Form</h3>
          <form className='contact-form'>
            <div className='form-input'>
              <label htmlFor="name">Name:</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className='form-input'>
              <label htmlFor="email">Email:</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className='form-input'>
              <label htmlFor="message">Message:</label>
              <textarea id="message" name="message" required></textarea>
            </div>
            <button type="submit" className='primary-btn btn-with-icon'>Send Message<FaIcon icon="circle-play" color="#000" /></button>
          </form>
        </div>
        <div className='card left-text width-50'>
          <h3 style={{ color: '#e47931' }}>Our Location</h3>
          <h1>Find Us Here</h1>
          <p>
            <FaIcon icon="map-marker-alt" />
            <a href='https://maps.app.goo.gl/qzNzBJmMjfz6SASk8' target="_blank" rel="noopener noreferrer">
              Sy No: 36, Plot No: 68B, Road No-18, Phase-1, KIADB Industrial Area, Masthenhalli, Kaiwara, Taluk: Chintamani, PIN: 562102</a>
          </p>
          <p>
            <FaIcon icon="envelope" />
            <a href="mailto:info@glometal.in">info@glometal.in</a>
          </p>
          <p>
            <FaIcon icon="phone" />
            <a href="tel:+919008688888">91 90086 88888</a>
          </p>
          <p>
            <FaIcon icon="globe" />
            <a href="https://glometal.in/">www.glometal.in/</a>
          </p>
          <p>
            <FaIcon icon="clock" />
            Business Hours:
            <div className='business-hours pad-l-2'>
              <p>Monday - Saturday: 9:00 AM - 5:30 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </p>
        </div>
        <p>We look forward to hearing from you!</p>

      </div>
    </div>
  );
};

export default Contact;